import axios from 'axios';
import store from '@/store';
import router from '@/router';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      store.dispatch('auth/logout');
      router.push({ name: 'Login' });
    }
    return Promise.reject(error);
  },
);

export default axios;
